import React, { useEffect, useRef } from 'react';
import './TeamStore.css';

const IFRAME_ID = 'fulfillengineiframe';
const FULFILL_ENGINE_SRC = 'https://app.fulfillengine.com/campaign/glass-city-gladiators';

/** Viewport height minus nav, container offset, and page title. */
function getMinIframeHeight() {
  if (typeof window === 'undefined') return 720;
  return Math.max(560, window.innerHeight - 200);
}

function applyIframeHeight(iframe, heightPx) {
  const h = Math.max(heightPx, getMinIframeHeight());
  iframe.style.height = `${h}px`;
  iframe.setAttribute('height', String(h));
}

/**
 * Fulfill Engine team store embed. Message listener matches their snippet so the
 * iframe can resize and request scroll adjustments.
 */
export default function TeamStore() {
  const scrollAnchorY = useRef(0);

  useEffect(() => {
    const iframe = document.getElementById(IFRAME_ID);
    if (iframe) applyIframeHeight(iframe, getMinIframeHeight());

    const onResize = () => {
      const el = document.getElementById(IFRAME_ID);
      if (!el) return;
      const current = parseInt(el.getAttribute('height') || '0', 10);
      applyIframeHeight(el, Math.max(current, getMinIframeHeight()));
    };
    window.addEventListener('resize', onResize);

    const onMessage = (e) => {
      if (!e || !e.data || e.data.length < 2) return;
      const frame = document.getElementById(IFRAME_ID);
      if (!frame) return;
      const [cmd, value] = e.data;
      if (cmd === 'setIframeHeight') {
        const requested = parseInt(value, 10) || 0;
        applyIframeHeight(frame, requested);
      } else if (cmd === 'iframeScrollUp') {
        const y = scrollAnchorY.current;
        const top = frame.getBoundingClientRect().y;
        if (top < y) {
          window.scrollTo(0, top + window.scrollY - y);
        }
      }
    };
    window.addEventListener('message', onMessage, false);
    return () => {
      window.removeEventListener('message', onMessage, false);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <div className="team-store-page">
      <h1 className="team-store-title">Team Store</h1>
      <div className="team-store-frame-wrap">
        <iframe
          id={IFRAME_ID}
          title="Glass City Gladiators team store"
          src={FULFILL_ENGINE_SRC}
          width="100%"
          height={getMinIframeHeight()}
          frameBorder={0}
          allowFullScreen
          className="team-store-iframe"
        />
      </div>
    </div>
  );
}
